import { useEffect, useState } from "react";
import { apiGet, apiPost } from '../../API/httpCommon';
import Spinner from '../Spinner/Spinner';
import { setUserDetails, getUserDetails } from '../../Utility/UserUtility';
import { useNavigate } from 'react-router-dom';
import { format, addDays } from 'date-fns';


const CancelRequest = () =>{

     const navigate = useNavigate();

     const [isLoading, setIsLoading] = useState(false);
     const [OrderList, setOrderList] = useState<any[]>([]);
     const [OrderDetailsList, setOrderDetailsList] = useState<any[]>([]);
     const [activePanel, setActivePanel] = useState<any>('CancelRequestList');

    useEffect(function(){
        
        let userDetails : any = getUserDetails();
        if(userDetails?.User?.User_Id){
            GetOrder();
        }
        else{
            navigate('/');
        }

       

    },[]);

 const GetOrder = () => {
        setIsLoading(true);
        let userDetails : any = getUserDetails();
        apiGet(`api/Order/CancelRequestGet?UserId=${userDetails?.User?.User_Id}`).then((res: any) => {
            
            setOrderList(res?.Data);
         setIsLoading(false);
    });
}

const handleViewDetail = (OrderId : any) =>{

    //navigate('/OrderStatus?oid='+OrderId);

      setOrderDetailsList([]);
    setIsLoading(true);
    let userDetails : any = getUserDetails();
    apiGet(`api/Order/CancelRequestDetailsGet?UserId=${userDetails?.User?.User_Id}&rid=${OrderId}`).then((res: any) => {
        
     setOrderDetailsList(res?.Data);
     setIsLoading(false);
     setActivePanel('CancelRequestDetails');
});

}

const handleBack = () =>{
    setActivePanel('CancelRequestList');
}


    return(<>
     {(isLoading && <Spinner></Spinner>)} 
     <div className=" breadcrumb-padding-180"></div>


{ (activePanel === 'CancelRequestList') && 
    <div className="cart-section section-padding">
        <div className="container">
			<div className="section-title-area">
                <div className="section-title center">
                    <h3 className="wow fadeInUp" data-wow-delay=".3s"><br/>Cancel Order Status	</h3>
                </div>
            </div>
            <div className="main-cart-wrapper">
			
                <div className="row g-5">
                    <div className="col-xl-12 Cancel">
                        <div className="table-responsive ">
						
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th className="cart-border">Request ID</th>
                                        <th className="cart-border">Order ID</th>
                                        <th className="cart-border">Request Date</th>
                                        <th className="cart-border">Reason</th>
                                        <th className="cart-border">Request Status</th>
                                        <th className="cart-border">Payment Status</th>
                                        <th className="cart-border">Details</th>
                                    </tr>
									<tr className="border-bottom"></tr>
                                </thead>
								
								
							
                                <tbody>
									
                                   {
                                        OrderList?.map(item =>(
                                            
                                    <tr>
                                        <td className="cart-border">
                                            <span className="cart-title">{item?.Request_Id}</span>
                                        </td>
										 <td className="cart-border">
                                            <span className="cart-title">{item?.Order_Id}	</span>
                                        </td>
										<td className="cart-border">
                                            <span className="cart-title">{format(item?.Request_Date, "dd-MMM-yyyy")}	</span>
                                        </td>
                                        <td className="cart-border">
                                            <span className="cart-title">{item?.Cancel_Reason}</span>
                                        </td>
										 <td className="cart-border">
                                            <span className="cart-title">{item?.Req_Status}</span>
                                        </td>
                                        <td className="cart-border">
                                            <span className="cart-title">{item?.Payment_Status}</span>
                                        </td>
										 <td className="cart-border">
                                           
                                         
                                             <span className="cart-title"><a className="theme-btn" onClick={() => handleViewDetail(item?.Request_Id)} >View Detail</a></span>
                                             {/* &nbsp;  {item?.Order_ShipStatus !== 'Cancelled' && item?.Order_ShipStatus !== 'Returned' && item?.Order_ShipStatus !== 'Undelivered' && <span className="cart-title"><a href="#" className="theme-btn">Invoice</a></span>  }  */}
                                        </td>
                                    </tr>

                                        ))

                                   } 
                                    
                                   
                                </tbody>
                            </table>
                        </div>
                        
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
}

{ (activePanel === 'CancelRequestDetails') && 
    <div className="cart-section section-padding">
        <div className="container">
			<div className="section-title-area">
                <div className="section-title center">
                    <h3 className="wow fadeInUp" data-wow-delay=".3s"><br/>Cancel Request Details Status	</h3>
                </div>
            </div>
            <div className="main-cart-wrapper">
			
                <div className="row g-5">
                    <div className="col-xl-12 Cancel">
                        <div className="table-responsive ">
						
                            <span> <b> Request ID :</b> {OrderDetailsList[0]?.Request_Id}&nbsp;&nbsp;&nbsp;</span> {"   "}
                            <span> <b> Order ID :</b> {OrderDetailsList[0]?.Order_Id}&nbsp;&nbsp;&nbsp;</span>  {"   "}
                            <span> <b> Cancel Request Date :</b> {format(OrderDetailsList[0]?.Request_Date, "dd-MMM-yyyy")}</span> 
                            
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th className="cart-border">Item Name</th>
                                        <th className="cart-border">Item Price</th>
                                        <th className="cart-border">Quantity</th>
                                        <th className="cart-border">Subtotal</th>
                                        <th className="cart-border">Ship Status</th>
                                        <th className="cart-border">Request Status</th>
                                    </tr>
									<tr className="border-bottom"></tr>
                                </thead>
								
								
							
                                <tbody>
									
                                   {
                                        OrderDetailsList?.map(item =>(
                                            
                                    <tr>
                                        <td className="cart-border">
                                            <span className="cart-title">{item?.Item_Title}</span>
                                        </td>
										 <td className="cart-border">
                                            <span className="cart-title">{item?.Item_Price}	</span>
                                        </td>
										<td className="cart-border">
                                            <span className="cart-title">{item?.Item_Quantity}	</span>
                                        </td>
                                        <td className="cart-border">
                                            <span className="cart-title">{(parseFloat(item?.Item_Price) * parseInt(item?.Item_Quantity))}</span>
                                        </td>
										 <td className="cart-border">
                                            <span className="cart-title">{item?.Order_ShipStatus}</span>
                                        </td>
                                        <td className="cart-border">
                                            <span className="cart-title">{item?.Request_Status}</span>
                                        </td>
										 
                                    </tr>

                                        ))

                                   } 
                                    
                                   
                                </tbody>
                            </table>

                            <span className="cart-title" style={{float:"right"}} ><a className="btn btn-secondary" onClick={() => handleBack()} >Back</a></span>

                        </div>
                        
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
}

    </>);
}

export default CancelRequest;